import { render, staticRenderFns } from "./RetentionFilter.vue?vue&type=template&id=5b982dda&scoped=true"
import script from "./RetentionFilter.vue?vue&type=script&lang=js"
export * from "./RetentionFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b982dda",
  null
  
)

export default component.exports